import axios from 'axios';
import { CoinData } from './type';

const BASE_URL = 'https://api.coingecko.com/api/v3';

export const ping = () => axios.get(`${BASE_URL}/ping`);

export const getVirtualPrice = (id?: string) =>
  axios
    .get<CoinData>(`${BASE_URL}/coins/virtual-protocol`)
    .then((response: any) => response.data);

export const getMarketChart = (id?: string) =>
  axios
    .get(
      `${BASE_URL}/coins/${
        id ?? 'virtual-protocol'
      }/market_chart?vs_currency=usd&days=1&interval=daily`
    )
    .then((response: any) => response.data);

export const getSimplePrice = () =>
  axios
    .get(
      `${BASE_URL}/simple/price?ids=virtual-protocol&vs_currencies=usd&include_24hr_vol=true`
    )
    .then((response: any) => response.data);

export const getConversionPrices = () =>
  axios
    .get(
      `${BASE_URL}/simple/price?ids=virtual-protocol%2Cethereum&vs_currencies=USD`
    )
    .then((response: any) => response.data);
